const logoMap = {
  mx: "logoAlt.svg",
  do: "logoAltSoy.svg",
  default: "logoAlt.svg",
};

export default logoMap;
